import styled from 'styled-components'

export const Perspective = styled.div`
    perspective: 100px;

    position: absolute;
    top: 0;
    left: 50%;
    right: 0;
    bottom: 0;
    margin-left: -1500px;

    height: 100vh;
    scroll-snap-type: y mandatory;
    overflow-x: hidden;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const App = styled.div`
    
    

    
`;

